import React from 'react';
import {Button, TextField, withStyles, MenuItem, Grid} from 'material-ui';
import styles from './style/styles';
import _find from 'lodash/find';
import _findIndex from 'lodash/findIndex';

const PagesFilters = ({
    classes,
    setFilter,
    resetFilters,
    filters,
    onFiltersApply,
    pageTypes,
    sites
}) => {

    let getSearchValues = (filters, filterName) => {
        let search = _find(filters, {id: filterName});
        let searchValue = search && search.value;

        return searchValue;
    }

    let site = _find(filters, {id: 'site_id' });
    let siteValue = site && site.value;

    // ugly hack, material ui next beta dd input sucks
    if (sites.length > 0) {
        let masterSiteIndex = _findIndex(sites, {id: 0});
        if (masterSiteIndex >= 0) {
            sites[masterSiteIndex].id = 999;
        }
        if (siteValue === 0) {
            siteValue = 999;
        }
    }

    return (
        <Grid>
            <Grid item xs={12} className={classes.container} noValidate autoComplete="off">
                <Grid container className={classes.containerLineOne}>
                    <Grid item xs={12} md={4}>
                        <TextField
                            id="title"
                            label="Title"
                            className={classes.textField}
                            value={getSearchValues(filters, 'title') || ''}
                            onChange={event => {
                                setFilter('title', event.target.value);
                            }}
                            margin="normal"
                        />
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <TextField
                            id="page_type_id"
                            select
                            label="Page Type"
                            className={classes.textField}
                            value={getSearchValues(filters, 'page_type_id') || -1}
                            onChange={event => {
                                setFilter('page_type_id', event.target.value);
                            }}
                            margin="normal"
                        >
                            <MenuItem key={-1} value={-1} className={classes.selectMenuItem}> - please select - </MenuItem>
                            {pageTypes.map(option => (
                                <MenuItem key={option.id} value={option.id} className={classes.selectMenuItem}>
                                    {option.type}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <TextField
                            id="site_id"
                            select
                            label="Site"
                            className={classes.textField}
                            value={siteValue || -1}
                            onChange={event => {
                                setFilter('site_id', event.target.value);
                            }}
                            margin="normal"
                        >
                            <MenuItem key={-1} value={-1} className={classes.selectMenuItem}> - please select - </MenuItem>
                            {sites.map(option => (
                                <MenuItem key={option.id} value={option.id} className={classes.selectMenuItem}>
                                    {option.display_name}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                </Grid>
            </Grid>
            <Grid className={classes.containerLineTwo}>
                <Button variant="raised" color="primary" className={classes.filterButton} onClick={onFiltersApply} style={{marginRight: 15 }}>
                    Filter
                </Button>
                <Button variant="raised" color="default" className={classes.filterButton} onClick={event => {resetFilters(filters)}}>
                    Reset Filters
                </Button>
            </Grid>
        </Grid>
    );
};

export default withStyles(styles)(PagesFilters);


// WEBPACK FOOTER //
// ./src/containers/pages/PagesFilters.jsx